import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RestaurantDetails } from '../../restaurants/models/List.Restaurant';
import { RestaurantService } from '../../restaurants/services/Restaurant.service';
import { eventType, ListData, ListFilter } from '../models/List.Event';
import { EventService } from '../services/Events.service';
import { EventFormComponent } from './event-form/event-form.component';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html'
})
export class EventsComponent implements OnInit {
  dataLoading = true;
  showFilter = false;
  showSearch = false;
  pageIndex = 0;
  pageCount = 0;
  typeValue!: any;
  pageSize = 10

  filterFormGroup: FormGroup = new FormGroup({});
  filterModel: ListFilter = new ListFilter();
  today = new Date();
  // Restaurant ID
  restaurantId?: any;
  allRestaurants: RestaurantDetails[] = [];

  typesListAll = [
    { name: this.translate.instant('content4.Upcoming & Ongoing'), id: eventType.UpcomingAndOngoing },
    { name: this.translate.instant("content4.Past"), id: eventType.Past }
  ];

  recordsData!: ListData | null;

  constructor(private translate: TranslateService,
    private restaurantService: RestaurantService,
    public dialog: MatDialog,
    private service: EventService,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    // static
    this.filterModel.pageNumber = 0;
    this.filterModel.pageSize = this.pageSize;

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['page']) {
        this.filterModel.pageNumber = Number(params['page']);
      }
      if (params['pageSize']) {
        this.filterModel.pageSize = Number(params['pageSize']);
      }
      if (params['status']) {
        this.typeValue = this.typesListAll.find(element => element.id === Number(params['status']));
      } else {
        this.typeValue = this.typesListAll[0]
      }
      if (params['page']) {
        this.getAll(true);
      } else {
        this.getAll(null);
      }
    });
  }



  getAll(event: any) {
    this.dataLoading = true;
    if (!event) {
      this.filterModel.pageNumber = 0;
      this.filterModel.pageSize = this.pageSize;
    }
    if (event && event.pageSize) {
      this.filterModel.pageNumber = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;
    }
    this.filterModel.status = this.typeValue?.id;
    this.service.getAll(this.filterModel).subscribe(
      (data: ListData) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data;
          this.pageCount = Math.ceil(this.recordsData.totalCount / this.filterModel.pageSize);
        }
      },
      (error: any) => {
        this.recordsData = null;
        this.dataLoading = false;
      });


  }

  public changePagingParams(event: any = null) {
    if (event && event.pageSize) {
      this.filterModel.pageNumber = event.pageIndex;
      this.filterModel.pageSize = event.pageSize;
    }
    const queryParams: Params = {
      page: this.filterModel.pageNumber,
      pageSize: this.filterModel.pageSize
    };
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  typeFilter(selected: any) {
    const selectedType = this.typesListAll.find(element => element.id === selected.value);
    if (selectedType) {
      this.typeValue = selectedType;
    }
    // this.getAll(true);
    this.filterModel.status = this.typeValue?.id;
    const queryParams: Params = {
      page: 0,
      pageSize: this.filterModel.pageSize,
      status: this.filterModel.status
    };
    this.router.navigate(
      [location.pathname],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryParams,
        queryParamsHandling: 'merge'
      });
  }


  openEventForm(record: any | null = null) {
    const dialogRef = this.dialog.open(EventFormComponent, {
      width: '530px',
      data: { record, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAll(true);
      }
    });
  }

  deleteRecord(recordId: string) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.delete(recordId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getAll(true);
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }
}
